/* eslint-disable @typescript-eslint/no-explicit-any */
// MultiSelectDropdown.tsx
import React, { useState } from "react";
import Select, { SingleValue } from "react-select";
import { useTranslation } from "../hooks/hooks";
import { useAtom } from "jotai";
import { activeCategoryAtom, categoriesAtom, currentPageAtom } from "../state/games";
import { getOptionsForCategories } from "../helpers/helpers";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";

const CategoriesDropdown = () => {
    const { _e } = useTranslation();
    const navigate = useNavigate();

    const [categories] = useAtom(categoriesAtom);
    const [activeCategory, setActiveCategory] = useAtom(activeCategoryAtom);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const options = categories ? getOptionsForCategories(categories, activeCategory, false) : [];
    const selected = categories ? getOptionsForCategories(categories, activeCategory, true) : null;
    const handleChange = (
        selected: SingleValue<{ value: number; label: string; slug: string }>,
    ) => {
        selected && setActiveCategory(selected.value);
        navigate(`${routes.pages.games}/${selected?.slug}`);
    };

    const customStyles = {
        menu: (provided: any, state: any) => ({
            ...provided,
            zIndex: "20",
        }),
    };
    return (
        <div className={menuIsOpen ? "select-dropdown-wrapper open" : "select-dropdown-wrapper"}>
            <Select
                isMulti={false}
                options={options}
                hideSelectedOptions={false}
                value={selected}
                onChange={handleChange}
                controlShouldRenderValue={false}
                placeholder={_e("Categories")}
                closeMenuOnSelect={false}
                styles={customStyles}
                classNamePrefix="select-dropdown"
                onMenuOpen={() => setMenuIsOpen(true)}
                onMenuClose={() => setMenuIsOpen(false)}
            />
        </div>
    );
};

export default CategoriesDropdown;
